import { useAppSelector } from '../../app/hooks';
import { VISIBILITY_KEYS } from '../../utils/constants/visibilityKeys';

/**
 * Whether the notification bell is enabled for the current PNO (visibility config
 * `notification.bell.enabled === 1`). Shared by Topbar (desktop) and MobileHeader (mobile)
 * so the selector isn't duplicated. Falls back to `additionalDetailsConfig` for the wrapped
 * config shape, matching `useVisibilityConfig`'s defensive read.
 * @returns true when the bell should render for this org.
 */
export function useNotificationBellEnabled(): boolean {
    return useAppSelector((state) => {
        const raw = state.user.visibilityConfig as any;
        const flat = raw?.additionalDetailsConfig ?? raw;
        return flat?.[VISIBILITY_KEYS.NOTIFICATION_BELL.ENABLED] === 1;
    });
}
